(function($) {

	$(document).ready(function() {

		$('.feature-gallery').featherlightGallery({
			gallery: {
				fadeIn	: 300,
				fadeOut	: 300
			},
			openSpeed	: 300,
			closeSpeed	: 300,
			afterOpen: function(event){
				$('.featherlight-previous').html("<i class='far fa-chevron-left'></i>");
				$('.featherlight-next').html("<i class='far fa-chevron-right'></i>");
			}
		});
	});

})(jQuery);